<template>
<div
  class="results-main"
>
  <router-view
    v-if="ready"
    :key="$route.fullPath"
  />
  <div
    v-if="!detailPageOpen"
  >
    <div class="columns is-centered  is-multiline results-address-box">
      <div
        class="column is-9"
      >
        <div
          class="columns is-centered is-multiline is-9"
        >
          <div class=" column is-9 grey-border">
            <div class="owner-info-item has-text-weight-bold">L&I district</div>
            <div
              class="owner-info-item address"
            >
              {{ this.$store.state.searchResults.li_district }}
            </div>
          </div>
          <div class="grey-border column is-9">
            <div class="owner-info-item has-text-weight-bold">Owner name</div>
            <div
              class="owner-info-item address"
            >
              <div
              v-for="item in ownerUpdate"
              :key="item"
              >
                {{ item }}
              </div>
            </div>
          </div>

          <div class=" column is-9">
            <div class="owner-info-item  has-text-weight-bold">Owner mailing address</div>
            <div
            class="owner-info-item address"
            >
              <div
                v-for="item in resultAddress"
                :key="item"
                >
                  {{ item }}
              </div>
            </div>
          </div>

        </div>
      </div>
          <div class=" column is-9 inquiry">
              To report corrections, 
                <a
                  target="_blank"
                  :href="'https://opainquiry.phila.gov/opa.apps/help/PropInq.aspx?acct_num='+this.$store.state.searchResults.opa_account_num"
                > 
                  submit an official inquiry.<i class="fa fa-external-link" aria-hidden="true"></i>
                </a>
          </div>
    </div>
    <div style="position: relative;">
    <div
      v-if="loading"
      class="columns is-centered"
    >
      <i class="fas fa-spinner fa-spin fa-3x" />
    </div>
      <Accordion
        :contents="contents"
        class="results-accordion"
        v-if="!loading"
      >
        <div
          class="contents-div"
          slot-scope="{ item }"
          v-if="item.msg && item.msg.length > 0"
        >
          <v-client-table
            class="results-table property-history"
            :data="filterData[item.title] ? filterData[item.title] : []"
            :columns="columnNames(item)"
            :dateFormat='dateFormat'
            :options="tableOptions(item)"
            :item="item"
            :ref="item.title"
          >
            <div
              v-for="(filter, index) in filterSettings"
              :key="index"
              slot ="beforeTable"
            >
              <div 
                v-if="item && index === item.title"
                class="columns is-centered is-12"
              >
              
                <div
                  v-for="filterItem in filter"
                  :key="filterItem.id"
                  class="column is-4"
                >
                  <dropdown
                    class="results-filter"
                    v-if="filterItem.type === 'dropdown'"
                    :label="'Filter by ' + filterItem.label"
                    :inner-label="false"
                    :options="dropdownValues( filterItem.name, item)"
                    :placeholder="filterItem.label"
                    @change="setFilter(item, filterItem.name, $event)" 
                  />
                  <textbox
                    v-if="filterItem.type === 'textbox'"
                    class="results-filter"
                    type="text"
                    icon="fas fa-filter"
                    :label="'Filter by ' + filterItem.label"
                    :inner-label="false"
                    :placeholder="'Type to filter by ' + filterItem.label.toLowerCase()"
                    v-model="value"
                    @change="setFilter(item, filterItem.name, $event)" 
                  /> 
                </div>
              </div>
            </div>

            <template v-for="item in columnNames(item)" :columns="columns" v-slot:[item]="props">
              
              <!--
                The following three v-if divs are hard-coded to the specific violations data in the state.
                This seemed to have been set up in 2020 to handle the violations data more elegantly here,
                but the violationsResults function of store/index.js seems to build an object that does not get
                stored in the state.
              -->
              <div 
                v-if="item === 'violationDisplayDate'"
                @click="openDetail({ row: props.row[0], href: 'violation-detail', violationNumber: props.row[0]['casenumber'] })"
              > 
                  {{ `${dateFormat(props.row[0]['casecreateddate'])}` }}
              </div>
              <div
                v-else-if="item === 'violationNumber'"
                @click="openDetail({ row: props.row[0], href: 'violation-detail', violationNumber: props.row[0]['casenumber'] })"
              > 
                  {{ `${props.row[0]['casenumber']}` }}  {{caseMessage(props.row.length)}}
              </div>
              <div 
                v-else-if="item === 'violationType'"
                @click="openDetail({ row: props.row[0], href: 'violation-detail', violationNumber: props.row[0]['casenumber'] })"
              > 
                  {{ `${props.row[0]['caseprioritydesc']}` }}
              </div>
              <div 
                v-else
                @click="openDetail(props.row)">
                {{ dateFormat(`${props.row[props.column]}`) }} 
              </div>
            </template>

          </v-client-table>
        </div>
      </Accordion>
    </div>

  </div>
</div>
</template>

<script>
import Accordion from '@/components/Accordion';
import _ from 'lodash';
import moment from 'moment'

export default {
  name: 'SearchResults',
  components: {
    Accordion,
  },
  props: {
    contents: null,
    column: null,
    item: null,
  },
  data() {
    return {
      value: "",
      ready: false,
      loading: false,
      columns: this.columnNames,
      // tableData: this.$store.state.permitResults.msg,
      options: {
        filterable: false,
        perPageValues: [],
        addSortedClassToCells: true,
      },
      filterData: {},
      filters: {},
      filterSettings: {
        "Appeals": [
          {
            name: 'appealsStatus',
            label: "Status",
            type: 'dropdown',
          },
          {
            name: 'appealsNumber',
            label: "Appeals #",
            type: 'textbox',
          },
          {
            name: 'appealsType',
            label: 'Type',
            type: 'dropdown',
          },
        ],
        // "Building Certifications": [
        //   {            
        //     name: "structure_id",
        //     type: "dropdown",
        //     label: "BIN",
        //   },
        // ],
        "Investigations": [
          {
            name: "indexGroup",
            type: "dropdown",
            label: "Year completed",
          },          
          {
            name: "casenumber",
            type: "textbox",
            label: "Case #",
          },          
          {
            name: "investigationstatus",
            type: "dropdown",
            label: "Status",
          },          
        ],
        "Business licenses": [
          {
            name: "indexGroup",
            type: 'dropdown',
            label: "Year issued"
          },
          {
            name: "licenseNumber",
            type: 'textbox',
            label: "License #",
          },
          {
            name: "licenseType",
            type: 'dropdown',
            label: "Type"
          },   
        ],
        "Permits": [
          {
            name: "indexGroup",
            type: "dropdown",
            label: "Year issued",
          },          
          {
            name: "permitNumber",
            type: "textbox",
            label: "Permit #",
          },          
          {
            name: "permitDescription",
            type: "dropdown",
            label: "Permit type",
          },
        ],
        "Violations": [
          {
            name: "indexGroup",
            type: "dropdown",
            label: "Year issued"
          },          
          {
            name: "violationNumber",
            type: "textbox",
            label: "Case #",
          },          
          {
            name: "violationType",
            type: "dropdown",
            label: "Type",
          },
        ]
      }
    }
  },
  async created() {
    // console.log('SearchResults created, this.$route:', this.$route, 'this.$store.state:', this.$store.state)
    if(typeof this.$route.query.Id  !== 'undefined') {
      try{
        let each = this.getRecord(this.$route.name, this.$route.query.Id)
        // console.log('SearchResults created, created hook opening detail, each:', each);
        await this.openDetail(each, true)
      } catch(err) {
        console.warn(err);
      } finally {
        this.ready = true;
        // this.$store.commmit('update',opa_address)
      }
    }

  },
  mounted () {
    // console.log('SearchResults.vue mounted, this.contents:', this.contents);
    this.contents.forEach(item => {
      // console.log('SearchResults.vue mounted, in loop item:', item);
      this.$set(this.filterData, item.title, item.msg);
      this.$set(this.filters, item.title, {});
      // this.filters[item.title]
    });

  },
  watch: {
    detailPageOpen(){
      // console.log("watching detail page state: ", this.$store.state.detailPage);
      this.$store.state.detailPage  ? "" : this.ready = false ;
    },
  },
  computed: {
    permitDate(){
      return "permitDate";
    },
    detailPageOpen(){
      return this.$store.state.detailPage
    },
    ownerUpdate(){
      if(this.$store.state.searchResults) {
        return this.$store.state.searchResults.opa_owners
      }
      return []
    },
    resultAddress(){
      let displayAddress = [];
      if(this.$store.state.mailingAddress) {
        if (this.$store.state.mailingAddress.mailing_address_1 || this.$store.state.mailingAddress.mailing_street) {
          let address = this.$store.state.mailingAddress;

          if( address.mailing_address_1){
            displayAddress.push(address.mailing_address_1)
            if( address.mailing_address_2){
              displayAddress.push(address.mailing_address_2)
            } else { 
              displayAddress.push( address.mailing_street )
            }
          } else {
            displayAddress.push( address.mailing_street )
          }
          displayAddress.push( address.mailing_city_state + " " + address.mailing_zip )
          return displayAddress;
        } else {
          let state = this.$store.state.searchResults;
          displayAddress.push(state.street_address)
          if(state.unit_type !== null && state.unit_num) {
            displayAddress.push([state.unit_type, state.unit_num].join(" "));
          } else if (state.unit_num && state.unit_num !== "") {
            displayAddress.push(["Unit", state.unit_num].join(" "));
          }
          displayAddress.push("PHILADELPHIA, PA " + state.zip_code)
          return displayAddress;
        } 
      } else {
        let state = this.$store.state.searchResults;
        displayAddress.push(state.street_address)
        if(state.unit_type !== null && state.unit_num) {
          displayAddress.push([state.unit_type, state.unit_num].join(" "));
        }  else if (state.unit_num && state.unit_num !== "") {
            displayAddress.push(["Unit", state.unit_num].join(" "));
          }
        displayAddress.push("PHILADELPHIA, PA " + state.zip_code)
        return displayAddress;
      }
    },

  },
  methods: {
    caseMessage(array) {
      return array === 1 ? " (1 violation)" : " (" + array + " violations)"
    },
    dropdownValues(column, data){
      // console.log("dropdown computed: ", column, data);
      let violationArray = []
        data.msg.forEach(
          a => violationArray.push(  a[column] )
        )
      return [...new Set(violationArray)].sort()
    },
    // sayRow(value) {
    // console.log(value)
    // },
    tableOptions(item) {
      return {
        ...this.options,
        headings: this.headingsFromColumns(item),
        // groupBy: 'indexGroup',
        hiddenColumns: ['indexGroup'],
        descOrderColumns: [this.columnNames(item)[0]],
        orderBy: {
          column : this.columnNames(item)[0],
          ascending: false,
        },
        pagination: {
          chunk: 5,
          nav: 'scroll',
        },
        sortIcon: {
          base:'glyphicon',
          up:'glyphicon-chevron-up',
          down:'glyphicon-chevron-down',
          is:'glyphicon-sort'
        },
        cellClasses: {
          permitNumber: [
            {
              class:'has-text-link has-text-weight-semibold',
              condition: () => true,
            }
          ],
          violationNumber: [
            {
              class:'has-text-link',
              condition: () => true,
            }
          ],
          appealsNumber: [
            {
              class:'has-text-link',
              condition: () => true,
            }
          ],
          structure_id: [
            {
              class:'has-text-link',
              condition: () => true,
            }
          ],
          casenumber: [
            {
              class:'has-text-link',
              condition: () => true,
            }
          ],
          licenseNumber: [
            {
              class:'has-text-link',
              condition: () => true,
            }
          ],
        },
      }
    },
    headingsFromColumns(item){
      // console.log("headingsFromColumns, headings value title: ", item.title);
      return item.title === 'Permits' ? { permitDate: "Date issued", permitNumber: "Permit #", permitDescription: "Permit type", indexGroup:  'Year'  } :
             item.title === 'Violations' ? { violationDisplayDate: "Date issued", violationNumber: "Violation case #", violationType: "Type", indexGroup: 'Index' } :
             item.title === 'Appeals' ? { appealsStatus: "Status", appealsNumber: "Appeals #", appealsType: "Type", indexGroup: 'Year'  } :
             item.title === 'Investigations' ? { investigationcompleted: "Date completed", casenumber: "Case #", investigationstatus: "Status", indexGroup: 'Year' } :
             item.title === 'Building Certifications' ? { structure_id: 'BIN' , totalMsg: 'Certifications' } :
             item.title === 'Business licenses' ? { licenseDateIssued: "Date issued", BusinessName: "Business Name", licenseNumber: "License #", licenseType: "Type", indexGroup: 'Year' } : ""

    },
    columnNames(item){
      // console.log("columnNames, naming columns, this:", this, 'item:', item);
      let value = [];
      if(item.title === "Permits"){
        // console.log("Columns are permits");
        value = ['permitDate', 'permitNumber', 'permitDescription', 'indexGroup' ]
      } else if (item.title === "Appeals") {
        value = ['appealsStatus', 'appealsNumber', 'appealsType', 'indexGroup']
      } else if (item.title === "Business licenses") {
        value = ['licenseDateIssued', 'BusinessName', 'licenseNumber', 'licenseType', 'indexGroup']
      } else if (item.title === "Building Certifications") {
        // console.log('if Building Certifications Summary');
        value = ['structure_id', 'totalMsg']
      } else if (item.title === "Investigations") {
        value = ['investigationcompleted', 'casenumber', 'investigationstatus', 'indexGroup']
      } else if (item.title === "Violations") {
        // console.log("columns names VIOLATIONS: ", item)
        value = ['violationDisplayDate','violationNumber', 'violationType', 'indexGroup'];
      }
      // console.log('columnNames end, value:', value);
      return value;
    },
    tableData(item){
      // console.log("tableData: ", typeof item, item.length, item);
      if(item.length > 0 ) {
        return item
      }
    },
    setFilter (item, filter, event) {
      // console.log(item, filter, event);
      let thisFilterObjects = this.filters[item.title];

      if(event.target) {
        thisFilterObjects[filter] = event.target.value;
      } else {
        thisFilterObjects[filter] = event;
      }

      if (event.target && event.target.value === '') {
        delete thisFilterObjects[filter];
      } else if(event === '') {
        delete thisFilterObjects[filter];
      }

      return this.filter(item);

    },
    filter (item) {
      // console.log("Beginning of filter: ", item, this.filters[item.title])
      let result = item.msg;

      Object.keys(this.filters[item.title]).forEach(filter => {
          result = result.filter(row => {
            // console.log("filter: ", this.filters, filter, this.filters[item.title][filter], row[filter]);
            return row[filter] == this.filters[item.title][filter];
          });
      });
      // console.log("End of filter: ", this.filterData)
      this.$set(this.filterData, item.title, result);
    },
    textFilter(key, filterKey, event) {
      // console.log(key, filterKey, event.target.value);

      const search = this.filterData[key].filter(item => {
        return item[filterKey] == event.target.value;
      });

      // console.log('search', search);

      this.$set(this.filterData, key, search);
      // console.log(this.filterData[key]);
      // console.log(this.$refs);
      // this.$refs[key].table.refresh();

    },
    dateFormat(date){
      // console.log('dateFormat, date.length:', date.length, moment(date).isValid(), moment(date));
      if (moment(date).isValid() && date.length > 19) {
        return moment(date).format('MMM DD, YYYY')
      }
      return date
    },
    async getZoningDocs(value){
      let sizeArray = [];
      await this.$store.dispatch('getZoningDocInfo', value.permitNumber).then(
        response => {
          let docIdList = [];
          response.forEach( a => {
            docIdList.push(a.doc_id + ".pdf");
          });

          docIdList.forEach(async a => {
            let sizeObject = new Object()
            // console.log("getting size hopefully from response: ", a, response)
            let eclipse = response.filter(obj => obj.doc_id + ".pdf" === a )[0]["eclipse"];
            let payload = { a: a, eclipse: eclipse }
            sizeObject.name = a;
            sizeObject.size = await this.$store.dispatch('getAWSFileSize', payload)
            sizeArray.push(sizeObject);
          });
          // console.log("Does size Array work?: ", sizeArray);
        }
      );
      return this.$store.commit('setZoningDocFileSizes', sizeArray);
    },
    getRecord(detailType, id){
      // console.log('getRecord:', this.$store.state.licenseResults, id, detailType, _.filter(this.$store.state.licenseResults.msg, {'licenseNumber':  "511412"}));
      let getEach = detailType === "appeal-detail" ? _.filter(this.$store.state.appealsResults.msg, {"appealsNumber": id}):
                    detailType === "permit-detail" ? _.filter(this.$store.state.permitResults.msg, {"permitNumber": id}) :
                    detailType === "business-license-detail" ? _.filter(this.$store.state.licenseResults.msg, {"licenseNumber": id }) :
                    detailType === "building-certification-detail" ? _.filter(this.$store.state.buildingCertificationSummaryResults.msg, {"structure_id": id }) :
                    detailType === "violation-detail" ? [this.$store.state.violationResults.msg[id]]: "";
      // console.log(getEach)
      return getEach[0];
    },
    getIdValue(value){
      // console.log('getIdValue, value:', value);
      return value.href === "appeal-detail" ? value.appealsNumber :
             value.href === "permit-detail" ? value.permitNumber :
             value.href === "business-license-detail" ? value.licenseNumber :
             value.href === "investigation-detail" ? value.casenumber :
             value.href === "building-certification-detail" ? value.structure_id :
             value.href === "violation-detail" ? value.violationNumber : "";
    },
    async openDetail(value, urlId) {
      console.log('openDetail is running, value:', value, 'urlId:', urlId);
      if(value && value.href === 'permit-detail') {
        await this.getZoningDocs(value);
      }
      let detailID = this.getIdValue(value);
      // console.log("openDetail, Each, detailID:", detailID, "value:", value, 'value.href:', value.href, 'urlId', urlId);

      if(value && value.href === 'investigation-detail') {
        // console.log(this.$store.state.violationResults.msg, value.casenumber);
        value = this.$store.state.violationResults.msg[value.casenumber];
      }

      await this.$store.commit("openDetail", value)
      // console.log("pushing route with detailId")

      if (!urlId) {
        this.$router.push( {
          name: value.href,
          query: { address: this.$route.query.address, Id: detailID }
      }).catch(()=>{});
      }
      return this.ready = true;
    },
  },
}
</script>

<style lang="scss" scoped>

.inquiry {
  display: inline-block;
  font-size: smaller;
}

.accordion-container {
  // margin: 25px 50px 0 50px;
  margin-top: 25px;
}
div.accordion-content {
  a {
    width: 100%;
  }
}


</style>
<style lang="scss">
.inquiry>a {
  color: $link-dark;
}
.property-history th {
  width: 33.3% !important;
}

div.results-dropdown > div > div.control > div.select {
  select {
    background-color: white;
    border: 2px solid $sidewalk-grey;
    height: auto;
  }
  &::after {
    margin-top: auto;
    top: 33%
  }
}

.results-accordion span.accordion-number {
  font-size: 1.25rem !important;
  // font-family: "Open Sans Light";
}

.results-main {
  // margin-top: 30px;
  padding: 0;
  .results-address-box {
    background-color: $ben-franklin-blue-light;
    // padding-bottom: 10px;
  }
}
@media (min-width: 768px) {
  div>div.results-address-box.columns {
    margin: 0;
  }
}
@media (max-width: 768px) {
  div>div.results-address-box {
    margin-left: -1rem;
    margin-right: -1rem;
  }
}
@media (min-width: 768px) {
  main.container.main > div {
      margin: 0;
  }
}

.owner-info-item {
  display: inline-block;
  width: 50%;
  vertical-align: top;
  &.address {
    float: right;
  }
}
.grey-border {
  border-bottom: 0.75px $grey-medium solid;
  display: flex;
}

div.accordion-content {
  display: flow-root;
  a {
    // float: right;
    font-size: .9em;
    text-transform: uppercase;
    // padding: 0 12px;
  }
}

</style>